import { Expose, Transform } from 'class-transformer';

import { Model } from './model';

export class ReservationsReport extends Model {
  @Expose() callStatus: string;
  @Expose() canceled: string;
  @Expose() isCanceled: boolean;
  @Expose() isNotifed: boolean;
  @Expose() reason: string;
  @Expose({ name: 'duration' }) callDurationSeconds: number;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  schduleSlotFromDate?: Date | null;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  schduleSlotToDate?: Date | null;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  scheduleDate?: Date | null;

  @Expose() scheduleRange: string;
  @Expose() timezone: string;
  @Expose()
  @Transform(({ obj }) => (obj && obj?.studentId && obj?.studentId?._id ? obj?.studentId?._id : null))
  studentId: string;
  @Expose()
  @Transform(({ obj }) => obj?.studentId?.userId)
  userId: string;
  @Expose()
  @Transform(({ obj }) => (obj && obj?.teacherId && obj?.teacherId?._id ? obj?.teacherId?._id : null))
  teacherId: string;
  @Expose()
  @Transform(({ obj }) => (obj && obj?.studentId && obj?.studentId?.fullName ? obj?.studentId?.fullName : null))
  studentName: string;
  @Expose()
  @Transform(({ obj }) => (obj && obj?.teacherId && obj?.teacherId?.fullName ? obj?.teacherId?.fullName : null))
  teacherName: string;
}
